<script setup lang="ts">
import { computed } from 'vue';
import { useLayoutStore } from '@/stores/layout';

const layout = useLayoutStore();

// The button advertises the layout you'll switch *to*, not the current one.
const label = computed(() =>
  layout.mode === 'top' ? 'Switch to side layout' : 'Switch to top layout',
);
</script>

<template>
  <button
    type="button"
    class="layout-toggle"
    :title="label"
    :aria-label="label"
    @click="layout.toggle()"
  >
    <!-- Top-bar glyph: a full-width bar across the top. -->
    <svg
      v-if="layout.mode === 'side'"
      class="layout-toggle__icon"
      viewBox="0 0 20 20"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="16" height="16" rx="2" />
      <rect class="layout-toggle__fill" x="2" y="2" width="16" height="5" rx="2" />
    </svg>
    <!-- Side-ribbon glyph: a full-height bar down the left. -->
    <svg v-else class="layout-toggle__icon" viewBox="0 0 20 20" aria-hidden="true">
      <rect x="2" y="2" width="16" height="16" rx="2" />
      <rect class="layout-toggle__fill" x="2" y="2" width="6" height="16" rx="2" />
    </svg>
  </button>
</template>

<style scoped>
.layout-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.12s, border-color 0.12s, background 0.12s;
}
.layout-toggle:hover {
  color: #2563eb;
  border-color: #93c5fd;
  background: #f8fafc;
}
.layout-toggle__icon {
  width: 18px;
  height: 18px;
}
.layout-toggle__icon rect {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.5;
}
.layout-toggle__icon .layout-toggle__fill {
  fill: currentColor;
  stroke: none;
}
</style>
